import React from 'react';
import PropTypes from 'prop-types';
import { PlusSvg } from '../../assets/svgs';
import { IconButton } from './icon-button.style';

const IconButtonComponent = ({
    type = 'button',
    icon: Icon = PlusSvg,
    outline = false,
    size = 'medium',
    color,
    className,
    ...props
}) => {
    return (
        <IconButton
            type={type}
            $outline={outline}
            size={size}
            color={color}
            className={className}
            {...props}
        >
            <Icon />
        </IconButton>
    );
};

IconButtonComponent.propTypes = {
    type: PropTypes.oneOf(['button', 'submit']),
    icon: PropTypes.elementType,
    outline: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    color: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
};

export default IconButtonComponent;
